import React from 'react'
import TargetImage from '../../../common/images/Target.png'
import { Box, Container, Typography } from '@mui/material'

export default function EmptyVulnerabilityDetails() {
  return (
    <Container
      maxWidth={'md'}
      sx={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        height: '35vh'
      }}
    >
      <Box width={'100%'} display={'flex'} flexDirection={'column'} alignItems={'center'}>
        <img src={TargetImage} alt='Logo' />
      </Box>
      <Box width={'100%'} display={'flex'} flexDirection={'column'} rowGap={1} pb={3} alignItems={'center'}>
        <Typography variant='body1' fontWeight={700} fontFamily={'Plus Jakarta Sans'}>
          No links or attachments were detected
        </Typography>
        <Typography textAlign={'center'} variant='body1' fontWeight={500} fontFamily={'Plus Jakarta Sans'}>
          No vulnerabilities were found in this email
        </Typography>
      </Box>
    </Container>
  )
}
